import { api } from '../configs/axiosConfigs';

export type MissingDataBehavior = 'zero' | 'fallback';

export type FixedCostSettings = {
  use_home_age: boolean;
  missing_age_behavior: MissingDataBehavior;
  age_fallback_tier: number;
  use_sqft: boolean;
  missing_sqft_behavior: MissingDataBehavior;
  default_sqft: number;
  contingency_enabled: boolean;
  contingency_percent: number;
  bounds_enabled: boolean;
  min_amount: number;
  max_amount: number | null;
  custom_rates_enabled: boolean;
  custom_rates: number[];
  apply_to_max_bid: boolean;
  apply_to_conditions: boolean;
};

export type FixedCostTier = {
  index: number;
  low: number;
  high: number | null; // null = no upper limit
  rate: number;
  label: string;
};

export type FixedCostSettingsResponse = {
  settings: FixedCostSettings & { rates: number[]; customized: boolean };
  defaults: FixedCostSettings;
  system_tiers: FixedCostTier[];
  engine_version: string;
};

export const getFixedCostSettings = async () => {
  return await api('/fixed_cost_settings');
};

export const updateFixedCostSettings = async (settings: FixedCostSettings) => {
  return await api.put('/fixed_cost_settings', { fixed_cost_settings: settings });
};
